//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useState, useEffect } from 'react';
// import { makeStyles } from '@material-ui/core';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { LayoutContext } from '../../common/contexts';
// import { setClassNameInDefns } from '../../common/definitionHelper';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
import { format, differenceInSeconds } from 'date-fns';
// import _get from 'lodash/get';
// import _set from 'lodash/set';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
// const useStyles = (params = {}) => {
//     return makeStyles(theme => ({
//         root: {
//             backgroundColor: '#FFFFFF',
//         },
//     }));
// };

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const formatAge = (seconds, dt, dateFormat) => {
    if (seconds < 60) {
        // less than a minute
        return `${seconds}s ago`;
    } else if (seconds < 3600) {
        // less than an hour
        return `${Math.floor(seconds / 60)}m ago`;
    } else if (seconds < 86400) {
        // less than a day
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds - hours * 3600) / 60);
        return `${hours}h ${minutes}m ago`;
    } else {
        return format(dt, dateFormat);
    }
};

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const LastMessageAgeCounter = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    // const classes = useStyles(/*{param1, param2}*/)();
    // const context = useContext(LayoutContext);
    // const xxxxxx = _get(context, 'xxxxxx');

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { typographyProps, dt, dateFormat = 'MM/dd/yy' } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [seconds, setSeconds] = useState(0);
    const [ageText, setAgeText] = useState('');

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        let interval = null;
        let increment = null;

        const ageInSeconds = differenceInSeconds(new Date(), dt);
        setAgeText(formatAge(ageInSeconds, dt, dateFormat));

        if (ageInSeconds < 60) {
            // less than a minute, count by second
            increment = 1000;
        } else if (ageInSeconds < 3600) {
            // less than an hour, count by minute
            increment = 60000;
        } else if (ageInSeconds < 86400) {
            // less than a day, count by hour
            increment = 3600000;
        } else {
            // more than a day, count by day
            increment = 86400000;
        }

        interval = setInterval(() => {
            setSeconds(seconds + increment / 1000);
        }, increment);

        return () => clearInterval(interval);
    }, [seconds, dt, dateFormat]);

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------
    // const defns = getDefns({classes, props})

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return <AfitdTypography {...typographyProps} value={ageText} />;
};

export default LastMessageAgeCounter;
